import { Card } from '@outbound-ai/ursa'
import { FormatTimeDate } from '../formatter'
import styled from 'styled-components'
import { BatchTabType, BatchType } from 'features/autocheck/types'

interface IBatchFileProps {
  params: any
  root: any
}

export const BatchFile = ({ params, root }: IBatchFileProps) => {
  return (
    <Div>
      <Card className="batch_files">
        <div className="batch_file_details">
          <table>
            <tbody>
              <tr>
                <td className="header">File Name</td>
                <td>{params.data.batchName}</td>
              </tr>
              <tr>
                <td className="header">Date and time uploaded </td>
                <td>{FormatTimeDate(params.data.created)}</td>
              </tr>
              {root === BatchTabType.Processed && params.data.batchType != BatchType.Claim_Import && (
                <tr>
                  <td className="header">Date and time finished</td>
                  <td>{FormatTimeDate(params.data.lastUpdatedTime)}</td>
                </tr>
              )}
              <tr>
                <td className="header">Uploaded by </td>
                <td>{params.data.uploaderUserName}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Card>
    </Div>
  )
}

const Div = styled.div`
  .batch_files {
    padding: ${({ theme }) => theme.spacing.s};
    main {
      padding: 0px !important;
    }
    h6 {
      ${({ theme }) => theme.typography.h6.medium};
      color: ${({ theme }) => theme.colors.primary.neutral}!important;
    }
    .batch_file_details {
      display: grid;
      gap: ${({ theme }) => theme.spacing.xxxs};
      table {
        width: 100%;
        tr {
          padding: 0 ${({ theme }) => theme.spacing.xxs}!important;
          height: 32px;
          .header {
            ${({ theme }) => theme.typography.s.medium};
            color: ${({ theme }) => theme.colors.grey.dark};
            width: auto;
            gap: ${({ theme }) => theme.spacing.xxxs};
            text-align: left;
            display: inline-flex;
            svg {
              color: ${({ theme }) => theme.colors.grey.neutral};
            }
          }
          td {
            ${({ theme }) => theme.typography.s.normal};
            color: ${({ theme }) => theme.colors.grey.dark};
            width: 70%;
            margin-top: ${({ theme }) => theme.spacing.xxxs};
            text-align: left;
            .header {
              ${({ theme }) => theme.typography.s.medium};
              color: ${({ theme }) => theme.colors.grey.dark};
              padding-bottom: ${({ theme }) => theme.spacing.xxs};
              width: 30%;
            }
          }
        }
      }
    }
  }
`
